export enum ImageLoading {
  EAGER = "eager",
  LAZY = "lazy",
}
